<template>
  <v-card width="330" class="ma-2">
    <v-card-title
      background-color="colorNeutralsNavy500"
      class="display-1 d-flex"
    >
      <span>{{ signupCode.code }}</span>
      <v-spacer />
      <v-chip :color="getColor(signupCode.used)">
        {{ signupCode.used ? "Used" : "Not Used" }}
      </v-chip>
    </v-card-title>
    <v-card-text>
      <div class="d-flex">
        <span>Used by:</span>
        <v-spacer />
        <span>{{ signupCode.usedUsername || "Not Used" }}</span>
      </div>
      <div v-if="signupCode.usedUserEmail" class="d-flex">
        <v-spacer />
        <span>{{ signupCode.usedUserEmail }}</span>
      </div>
      <div class="d-flex">
        <span>Used at:</span>
        <v-spacer />
        <span>{{ signupCode.usedTime | formatDate("MM/dd/yyyy h:mm a") }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDate } from "@/services/format";

export default {
  name: "SignupCodeCard",
  props: {
    signupCode: {}
  },
  methods: {
    getColor(used) {
      return used
        ? "colorSemanticStateGreen200"
        : "colorSemanticStateYellow200";
    }
  },
  filters: {
    formatDate
  }
};
</script>

<style scoped></style>
